import { trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { moveUpIfLeaveOnly } from '../../animations/move-up.if.animation';
import { sleep } from '../../lib/sleep';
import { CookieBannerService } from '../../services/cookie-banner.service';
import { ButtonDirective } from '../../shared/directives/button.directive';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  standalone: true,
  imports: [ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('smallCookieBanner', moveUpIfLeaveOnly)],
})
export class CookieBannerComponent {
  private cookieBannerService = inject(CookieBannerService);
  @HostListener('window:scroll') onScroll() {
    if (this.showExtra) return;
    this.hide(); // hide on scroll
  }
  public showExtra = false;
  hidden = false;

  async hide() {
    this.hidden = true;
    await sleep(250);
    this.cookieBannerService.hide();
  }
}
